import styled from 'styled-components';

/** Use to center content with images both vertically and horizontally */
export const ButtonCenteredContent = styled.div<{ $gap?: string }>`
  display: flex;
  align-items: center;
  gap: ${({ $gap }) => $gap || '4px'};
  justify-content: center;
`;
